import React, { Component } from 'react';

import { StringUtils, DateUtils, ArrayUtils } from '../utils';
import { History as history, Routes as routes } from '../navigation';
import { Button, Header, Line } from '../components';
import throttle from 'lodash/throttle';

import '../css/SignIn.css';

/* Props
consultations
users
patients
consultation_ids
status
*/

class ConsultationsList extends Component {

  constructor(props) {
    super(props);
    let status = this.props.status;
    this.state = {
      displayCount: 5,
      status: status,
      consultations: [],
      last_update_time: 0,
    }
    this.consoleLogFunc = this.consoleLog;
  }

  renderLabelRow = () => {
    let display_date = this.state.status === 'ACTIVE' ? true : false;
    if (this.state.status === 'UNASSIGNED') {
      return this.renderUnassignedLabelRow();
    }
    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ paddingTop: 3, paddingBottom: 3 }}>
        <div style={{ width: '48%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', paddingLeft: 15 }}>SUBJECT</div>
        <div style={{ width: '22%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>CLIENT</div>
        <div style={{ width: '15%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>PATIENT</div>
        <div style={{ width: '15%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>{ display_date ? 'CREATED' : 'RESOLVED' }</div>
      </div>
      <Line />
    </div>
  }

  renderUnassignedLabelRow = () => {
    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ paddingTop: 3, paddingBottom: 3 }}>
        <div style={{ width: '48%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', paddingLeft: 15 }}>SUBJECT</div>
        <div style={{ width: '37%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>LOCATION</div>
        <div style={{ width: '15%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>{ 'CREATED' }</div>
      </div>
      <Line />
    </div>
  }

  renderUnassignedRow = (consultation) => {
    let subject = consultation.subject;
        subject = subject.length > 45 ? subject.substr(0,42) + '...' : subject;
    let location_id   = consultation.location_id || '';
    let location      = ArrayUtils.getSingleObject(consultation.location);
    let location_name = location.name ? location.name : '';
    let created_date  = DateUtils.getShortMonth(consultation.created_at) + ' ' + DateUtils.getDateNumber(consultation.created_at);
    let displayBadge  = this.props.notifications && this.props.notifications[consultation._id] ? true : false;

    return <div key={consultation._id} className='flex-container-column'>
      <div className='flex-container-row standard-selection-row' style={{ paddingTop: 10, paddingBottom: 10, alignItems: 'center' }} onClick={ () => { this.props.consultationsActions.openConsultation(this.props.token, consultation) }}>
        <div style={{ width: '48%', color: '#454545', paddingLeft: 15, fontSize: 13 }}>{ subject }</div>
        <div style={{ width: '37%', color: 'grey', fontSize: 13 }}>{ location_name }</div>
        <div style={{ width: '15%', color: 'grey', fontSize: 13, alignItems: 'center', justifyContent: 'space-between' }} className='flex-container-row'>
          { created_date }
          { displayBadge ? <span style={{ height: 6, width: 6, borderRadius: 3, backgroundColor: 'red', marginRight: 10 }}></span> : null }
        </div>
      </div>
      <Line style={{ backgroundColor: '#f5f5f5' }} />
    </div>
  }

  renderConsultationRows = (consultations) => {
    let rows = [];

    rows = consultations.map((consultation) => {

      if (this.state.status === 'UNASSIGNED') {
        return this.renderUnassignedRow(consultation);
      }

      let client  = ArrayUtils.getSingleObject(consultation.client);
      let patient = ArrayUtils.getSingleObject(consultation.patient);
      let subject = consultation.subject;
          subject = subject.length > 45 ? subject.substr(0,42) + '...' : subject;
      let client_name  = StringUtils.displayName(client);
      let patient_name = StringUtils.displayName(patient);
      let created_date = DateUtils.getShortMonth(consultation.created_at) + ' ' + DateUtils.getDateNumber(consultation.created_at);
      let resolved_dte = consultation.resolved_at ? DateUtils.getShortMonth(consultation.resolved_at) + ' ' + DateUtils.getDateNumber(consultation.resolved_at) : DateUtils.getShortMonth(consultation.updated_at) + ' ' + DateUtils.getDateNumber(consultation.updated_at);
      let date_str     = this.state.status === 'ACTIVE' ? created_date : resolved_dte;
      let displayBadge = this.props.notifications && this.props.notifications[consultation._id] ? true : false;
      let display_pending = this.state.status === 'PROCESSING' ? true : false;

      return <div key={consultation._id} className='flex-container-column'>
        <div className='flex-container-row standard-selection-row' style={{ paddingTop: 10, paddingBottom: 10, alignItems: 'center' }} onClick={ () => { this.props.consultationsActions.openConsultation(this.props.token, consultation) }}>
          <div style={{ width: '48%', color: 'grey', paddingLeft: 15, fontSize: 13 }}>{ subject }</div>
          <div style={{ width: '22%', color: 'grey', fontSize: 13 }}>{ client_name }</div>
          <div style={{ width: '15%', color: 'grey', fontSize: 13 }}>{ patient_name }</div>
          <div style={{ width: '15%', color: 'grey', fontSize: 13, alignItems: 'center', justifyContent: 'space-between' }} className='flex-container-row'>
            { !display_pending ? date_str : null }
            { display_pending  ? <span style={{ padding: 3, backgroundColor: '#e8f8ff', color: '#1dc2ff', fontWeight: 'bold', fontSize: 11, paddingRight: 11, paddingLeft: 11, borderRadius: 10 }}>Processing</span> : null }
            { displayBadge ? <span style={{ height: 6, width: 6, borderRadius: 3, backgroundColor: '#F71735', marginRight: 10 }}></span> : null }
          </div>
        </div>
        <Line style={{ backgroundColor: '#f5f5f5' }} />
      </div>
    })

    return rows;
  }

  renderConsultations = () => {
    let consultations_dict    = this.props.consultations || {};
    let consultations_status  = this.props.status || '';
    let consultations         = consultations_dict[consultations_status] || [];

    let consult_rows  = this.renderConsultationRows(consultations);
    let status_props  = this.getStatusBasedProperties();
    let icon_class    = status_props.icon_class;
    let icon_color    = status_props.icon_color;

    let second_btn_title  = this.props.status === 'ACTIVE' ? 'Start Consultation' : '';
        second_btn_title  = this.props.hide_start_button ? '' : second_btn_title;
    let second_btn_action = () => { history.push(routes.CONSULTATION_START) };

    let empty_message     = 'There are no ' + status_props.title;
        empty_message     = this.props.status === 'RESOLVED' ? 'You have no resolved consultations...yet!' : empty_message;

    return <div className='standard-container'>
      <Header title={status_props.title}
              icon={icon_class}
              button_title='View All'
              button_action={ () => {
                this.props.consultationsActions.updateConsultationsScreenStatus(this.props.status, 1);
                if (this.props.is_front_desk) {
                  history.push(routes.CONSULTATIONS)
                } else {
                  history.replace(routes.CONSULTATIONS)
                }
              }}
              iconColor={icon_color} second_btn_title={second_btn_title}
              second_btn_action={second_btn_action} />
      { this.renderLabelRow() }
      { consult_rows }
      { consult_rows.length === 0 ? <div className='flex-container-column' style={{ height: 100, justifyContent: 'center', alignItems: 'center', fontSize: 14, color: 'grey' }}>{ empty_message }</div> : null }
    </div>
  }

  render() {
    return this.renderConsultations();
  }

  getConsultationsFromIds = (dict, ids) => {
    let consultation_ids   = ids  || [];
    let consultation_dict  = dict || {};
    let consultations      = [];
    let filter_location_id = this.props.filter_location_id || '';
    let filter_by_location = filter_location_id && filter_location_id !== '' ? true : false;

    consultation_ids.forEach((consultation_id, index) => {
      let consult_info = consultation_dict[consultation_id];
      let pass_filter  = filter_by_location && filter_location_id && consult_info.location_id && consult_info.location_id !== filter_location_id ? false : true;
      if (consult_info && index < 6 && pass_filter) {
        consultations.push(consult_info);
      }
    });

    return consultations;
  }

  getStatusBasedProperties = () => {
    let status_props = {
      icon_class: 'fa-notes-medical',
      icon_color: '#1dc2ff',
      title: 'Active Consultations',
    }
    if (this.props.status === 'RESOLVED') {
      status_props.icon_class = 'fa-clipboard-check';
      status_props.icon_color = '#66D56F';
      status_props.title      = 'Resolved Consultations'
    }
    if (this.props.status === 'PROCESSING') {
      status_props.icon_color = 'red';
      status_props.title      = 'Processing Consultations';
    }
    if (this.props.status === 'UNASSIGNED') {
      status_props.icon_class = 'fa-clipboard';
      status_props.title      = 'Unassigned Consultations';
    }
    return status_props;
  }

}


export default ConsultationsList
